import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Search, GitCompareArrows, PhoneCall } from "lucide-react";

const STEPS = [
    {
        icon: Search,
        title: "Browse & compare",
        desc: "Filter by budget, brand, and fuel type. Check specs and EMI on the same page.",
        link: "/#inventory",
        linkLabel: "Start browsing",
    },
    {
        icon: GitCompareArrows,
        title: "Shortlist your bike",
        desc: "Compare models side by side or save favourites before you visit the showroom.",
        link: "/compare",
        linkLabel: "Compare bikes",
    },
    {
        icon: PhoneCall,
        title: "Get on-road quote",
        desc: "Call, WhatsApp, or request a callback. Book a test ride at your nearest outlet.",
        link: "/dealers",
        linkLabel: "Find outlet",
    },
];

const HomeHowItWorks = ({ pages = {} }) => (
    <section className="py-10 sm:py-14 bg-[#F4F6F8] border-t border-zinc-100" data-testid="home-how-it-works">
        <div className="container-x">
            <div className="text-center mb-8 sm:mb-10">
                <p className="text-[11px] font-semibold text-[#E31837] tracking-wide uppercase">{pages.home_how_eyebrow || "Simple process"}</p>
                <h2 className="font-display text-3xl sm:text-4xl text-[#0A2540] mt-2 leading-tight">{pages.home_how_title || "How to buy with Servall"}</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
                {STEPS.map((step, i) => {
                    const Icon = step.icon;
                    return (
                        <motion.div
                            key={step.title}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.08 }}
                            className="bg-white rounded-2xl border border-zinc-200 p-6 sm:p-7"
                        >
                            <div className="flex items-center gap-3 mb-3">
                                <span className="w-10 h-10 rounded-xl bg-[#E31837]/10 text-[#E31837] flex items-center justify-center">
                                    <Icon size={20} />
                                </span>
                                <span className="text-xs font-semibold text-zinc-400">Step {i + 1}</span>
                            </div>
                            <h3 className="font-heading font-semibold text-lg text-[#0A2540]">{step.title}</h3>
                            <p className="text-sm text-zinc-500 mt-2 leading-relaxed">{step.desc}</p>
                            <Link
                                to={step.link}
                                className="inline-block mt-4 text-sm font-semibold text-[#E31837] hover:underline"
                                data-testid={`home-step-${i + 1}`}
                            >
                                {step.linkLabel}
                            </Link>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default HomeHowItWorks;
